import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  data: any = {};

  constructor() {
    this.init();
  }

  // init() {
  //   console.log('init');
  //   this.data = {};

  //   const cookies = document.cookie ? document.cookie.split(';') : [];

  //   console.log('cookies', cookies);

  //   for (let cookie of cookies) {
  //     const [rawKey, rawValue] = cookie.split('=');
  //     const key = rawKey.trim();
  //     const value = decodeURIComponent(rawValue);
  //     this.data[key] = value;
  //   }

  //   console.log('store', this.data);
  // }

  init() {
    console.log('init');

    const store = localStorage.getItem('store');
    this.data = store ? JSON.parse(store) : {};
    console.log('store', this.data);
  }

  public set(payload: Record<string, any>): void {
    this.data = { ...this.data, ...payload };
    localStorage.setItem('store', JSON.stringify(this.data));
  }

  // public set(payload: Record<string, any>): void {
  //   for (const key in payload) {
  //     if (payload.hasOwnProperty(key)) {
  //       const value = encodeURIComponent(payload[key]);
  //       const expires = new Date();
  //       expires.setDate(expires.getDate() + 7); // Cookie expires in 7 days
  //       document.cookie = `${key}=${value}; expires=${expires.toUTCString()}; path=/`;
  //     }
  //   }
  // }

  // public get(key: string): string | null {
  //   const nameEQ = key + '=';
  //   const cookies = document.cookie.split(';');
  //   for (let c of cookies) {
  //     c = c.trim();
  //     if (c.indexOf(nameEQ) === 0) {
  //       return decodeURIComponent(c.substring(nameEQ.length));
  //     }
  //   }
  //   return null;
  // }

  // public clearStore(): void {
  //   const cookies = document.cookie.split(';');
  //   for (let cookie of cookies) {
  //     const eqPos = cookie.indexOf('=');
  //     const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
  //     document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  //   }
  //   this.data = {};
  // }

  public get(key: string): any {
    console.log('ley', this.data[key]);
    return this.data[key];
  }

  public clearStore(): void {
    localStorage.removeItem('store');
    this.data = {};
  }
}
